<div
    *ngIf="!inView()"
    class="st-story-item-content-container"></div>
<div
    *ngIf="inView()"
    class="st-story-item-border-left"
    st-left-border
    [data]="data()"></div>
@switch (cardViewType()) {
    @case (CardViewTypes.SMALL) {
        <ng-container *ngTemplateOutlet="smallCard" />
    }
    @case (CardViewTypes.MEDIUM) {
        <ng-container *ngTemplateOutlet="mediumCard" />
    }
    @default {
        <ng-container *ngTemplateOutlet="largeCard" />
    }
}
<ng-template #largeCard>
    <div
        *ngIf="inView()"
        class="st-story-item-content-container"
        [class.st-story-item-content-container__mouse-entered]="mouseEntered"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()">
        <div class="st-story-item-content-container__static">
            <div class="st-story-item-content-container-main">
                <div class="st-story-item-content-container-main-top-row">
                    <span class="st-story-item-content-container-main__type">{{ scriptStoryTypeLabel$ | ngrxPush }}</span>
                    @if (!data()?.isNewRecord) {
                        <span class="st-story-item-content-container-main__word-count">{{ wordCount() }}</span>
                        <span class="st-story-item-content-container-main__time-updated">{{ timeUpdatedLabel }}</span>
                        <span class="st-story-item-content-container-main__updated-by">{{ updatedBy }}</span>
                    }
                </div>
                <st-text-area-overlay
                    required
                    class="st-story-item-content-container-main__slug"
                    minRows="1"
                    maxHeight="1rem"
                    maxLength="50"
                    disableNewLine
                    panelClass="st-story-item-content-container-main__slug"
                    [value]="data()?.Title"
                    [disabled]="cardDisabled()"
                    [textToHighlight]="searchString$ | ngrxPush"
                    [placeholder]="languageSettings.PSTWebSlugPlaceholder"
                    (changed)="updateStory($event, PSTFieldNames.Title)" />
                <st-text-area-overlay
                    required
                    class="st-story-item-content-container-main__summary"
                    maxRows="3"
                    minRows="3"
                    minHeight="3rem"
                    panelClass="st-story-item-content-container-main__summary"
                    disabled
                    [value]="storyText()"
                    [textToHighlight]="searchString$ | ngrxPush"
                    [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.Description]?.DefaultCaption" />
                <st-tags-autocomplete
                    [value]="data()?.Tags"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTTags]"
                    [maxItemsToShow]="maxTagsToShow()"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTTags]?.Required"
                    [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTTags]?.DefaultCaption"
                    (changed)="updateStory($event, PSTFieldNames.PSTTags)" />
            </div>
            <div class="st-story-item-content-container-meta">
                <div class="st-story-item-content-container-meta__row">
                    <st-date-time-picker
                        *ngIf="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Validation?.toUpperCase() === FieldDefValidations.TIME; else datePicker"
                        class="st-story-item-content-container-meta__date-picker"
                        asCustomField
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.TargetPublicationDate]"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Required"
                        [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.DefaultCaption"
                        [value]="data()?.[PSTFieldNames.TargetPublicationDate]"
                        (onTimezoneChanged)="timezoneChanged(PSTFieldNames?.TargetPublicationDate, $event)"
                        (changed)="updateStory($event, PSTFieldNames.TargetPublicationDate)" />
                    <ng-template #datePicker>
                        <st-date-picker
                            class="st-story-item-content-container-meta__date-picker"
                            [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Required"
                            [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.DefaultCaption"
                            [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.TargetPublicationDate]"
                            [value]="data()?.[PSTFieldNames.TargetPublicationDate]"
                            (changed)="updateStory($event, PSTFieldNames.TargetPublicationDate)" />
                    </ng-template>
                    <st-status
                        class="st-story-item-content-container-meta__status"
                        [value]="data()?.PSTStoryStatus"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTStoryStatus]"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.Required"
                        [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.DefaultCaption"
                        [matTooltip]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForField(PSTFieldNames.PSTStoryStatus)"
                        (changed)="updateStory($event, PSTFieldNames.PSTStoryStatus)" />
                    <div class="st-story-item-content-container-actions">
                        <button
                            *ngIf="approvedVisible() && !cardDisabled()"
                            class="st-story-item-content-container-actions__approve"
                            mat-icon-button
                            [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.Approved]"
                            [matTooltip]="globalTablesService.FieldDefsDict[PSTFieldNames?.Approved]?.DefaultCaption"
                            [class.st-story-item-content-container-actions__approve--active]="data()?.Approved"
                            (click)="updateStory(!data()?.Approved, PSTFieldNames.Approved)">
                            <mat-icon>done</mat-icon>
                        </button>
                        <button
                            class="st-story-item-content-container-actions__fullscreen"
                            mat-icon-button
                            [matTooltip]="displayOpenActionButtonHoverTitle()"
                            [disabled]="preview()"
                            (click)="itemClicked.emit()">
                            <mat-icon>fullscreen</mat-icon>
                        </button>
                        <st-external-actions-overlay
                            [inSidecarOpened]="inSidecarOpenedMode()"
                            [inFullScreen]="inFullscreenMode()"
                            [data]="data()"
                            [disabled]="cardDisabled()"
                            [editable]="!cardDisabled()"
                            [onObjectOpen]="itemClicked" />
                    </div>
                </div>
                <div class="st-story-item-content-container-meta__row">
                    <st-desk
                        class="st-topic-item-content-container-assigns__desk"
                        [value]="data()?.PSTGroup"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTDesk]"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.Required"
                        [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.DefaultCaption"
                        [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForDesk(data()?.Type)"
                        (changed)="updateStory($event, PSTFieldNames.PSTDesk)" />
                    <st-staff-id-list
                        class="st-story-item-content-container-assigns__owners"
                        [value]="data()?.PSTStoryOwner"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTStoryOwner]"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryOwner]?.Required"
                        [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryOwner]?.DefaultCaption"
                        (changed)="updateStory($event, PSTFieldNames.PSTStoryOwner)" />
                </div>
                <div class="st-story-item-content-container-meta__row">
                    <st-topic-button
                        class="st-story-item-content-container__topic-button"
                        [class.st-story-item-content-container__topic-button--readonly]="!inFullscreenMode()"
                        [value]="topicRecord()?.Title"
                        [label]="addToTopicLabel()"
                        [inFullScreenMode]="showFullCard"
                        (topicOpenEmitter)="onTopicOpenHandler(topicRecord())" />
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #mediumCard>
    <div
        *ngIf="inView()"
        class="st-story-item-content-container__medium"
        [class.st-story-item-content-container__mouse-entered]="mouseEntered"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()">
        <div class="st-story-item-content-container__medium__left-column">
            <span class="st-story-item-content-container__medium__type">{{ scriptStoryTypeLabel$ | ngrxPush }}</span>
            <div class="st-story-item-content-container__medium__main-content">
                <st-text-area-overlay
                    required
                    class="st-story-item-content-container-main__slug"
                    minRows="1"
                    maxHeight="1rem"
                    maxLength="50"
                    maxRows="1"
                    disableNewLine
                    panelClass="st-story-item-content-container-main__slug"
                    [value]="data()?.Title"
                    [disabled]="cardDisabled()"
                    [textToHighlight]="searchString$ | ngrxPush"
                    [placeholder]="languageSettings.PSTWebSlugPlaceholder"
                    (changed)="updateStory($event, PSTFieldNames.Title)" />
                <st-text-area-overlay
                    class="st-story-item-content-container-main__summary"
                    maxRows="2"
                    minHeight="2rem"
                    panelClass="st-story-item-content-container-main__summary"
                    disabled
                    [value]="storyText()"
                    [textToHighlight]="searchString$ | ngrxPush"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.Description]?.Required"
                    [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.Description]?.DefaultCaption"
                    (changed)="updateStory($event, PSTFieldNames.Description)" />
            </div>
            <div class="st-story-item-content-container__medium__metadata">
                <st-desk
                    class="st-topic-item-content-container-assigns__desk"
                    [value]="data()?.PSTGroup"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTDesk]"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.Required"
                    [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.DefaultCaption"
                    [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.DefaultCaption"
                    [itemList]="globalTablesService.getListItemsForDesk(data()?.Type)"
                    [maxItemsToShow]="0"
                    (changed)="updateStory($event, PSTFieldNames.PSTDesk)" />
                <st-staff-id-list
                    class="st-story-item-content-container-assigns__owners"
                    [value]="data()?.PSTStoryOwner"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTStoryOwner]"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryOwner]?.Required"
                    [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryOwner]?.DefaultCaption"
                    [maxItemsToShow]="0"
                    (changed)="updateStory($event, PSTFieldNames.PSTStoryOwner)" />
                <st-topic-button
                    class="st-story-item-content-container__topic-button"
                    [class.st-story-item-content-container__topic-button--readonly]="!inFullscreenMode()"
                    [value]="topicRecord()?.Title"
                    [label]="addToTopicLabel()"
                    [inFullScreenMode]="showFullCard"
                    (topicOpenEmitter)="onTopicOpenHandler(topicRecord())" />
            </div>
        </div>
        <div class="st-story-item-content-container__medium__right-column">
            <div
                class="st-story-item-content-container-main__time-updated-by"
                [title]="wordCount() + ' ' + timeUpdatedByLabel">
                {{ wordCount() + ' ' + timeUpdatedByLabel }}
            </div>
            <st-date-time-picker
                *ngIf="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Validation?.toUpperCase() === FieldDefValidations.TIME; else datePicker"
                class="st-story-item-content-container-meta__date-picker"
                asCustomField
                [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.TargetPublicationDate]"
                [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Required"
                [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.DefaultCaption"
                [value]="data()?.[PSTFieldNames.TargetPublicationDate]"
                (onTimezoneChanged)="timezoneChanged(PSTFieldNames?.TargetPublicationDate, $event)"
                (changed)="updateStory($event, PSTFieldNames.TargetPublicationDate)" />
            <ng-template #datePicker>
                <st-date-picker
                    class="st-story-item-content-container-meta__date-picker"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Required"
                    [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.DefaultCaption"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.TargetPublicationDate]"
                    [value]="data()?.[PSTFieldNames.TargetPublicationDate]"
                    (changed)="updateStory($event, PSTFieldNames.TargetPublicationDate)" />
            </ng-template>
            <div class="st-story-item-content-container__medium__right-column__status">
                <st-status
                    class="st-story-item-content-container-meta__status"
                    [value]="data()?.PSTStoryStatus"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTStoryStatus]"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.Required"
                    [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.DefaultCaption"
                    [matTooltip]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.DefaultCaption"
                    [itemList]="globalTablesService.getListItemsForField(PSTFieldNames.PSTStoryStatus)"
                    (changed)="updateStory($event, PSTFieldNames.PSTStoryStatus)" />
                <button
                    *ngIf="approvedVisible() && !cardDisabled()"
                    class="st-story-item-content-container-actions__approve"
                    mat-icon-button
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.Approved]"
                    [matTooltip]="globalTablesService.FieldDefsDict[PSTFieldNames?.Approved]?.DefaultCaption"
                    [class.st-story-item-content-container-actions__approve--active]="data()?.Approved"
                    (click)="updateStory(!data()?.Approved, PSTFieldNames.Approved)">
                    <mat-icon>done</mat-icon>
                </button>
                <button
                    class="st-story-item-content-container__fullscreen"
                    mat-icon-button
                    [matTooltip]="displayOpenActionButtonHoverTitle()"
                    [disabled]="preview()"
                    (click)="itemClicked.emit()">
                    <mat-icon>fullscreen</mat-icon>
                </button>
                <st-external-actions-overlay
                    class="st-story-item-content-container-actions__external"
                    [inSidecarOpened]="inSidecarOpenedMode()"
                    [inFullScreen]="inFullscreenMode()"
                    [data]="data()"
                    [disabled]="cardDisabled()"
                    [editable]="!cardDisabled()"
                    [onObjectOpen]="itemClicked" />
            </div>
        </div>
    </div>
</ng-template>

<ng-template #smallCard>
    <div
        *ngIf="inView()"
        class="st-story-item-content-container__mobile">
        <div class="st-story-item-content-container__mobile__left">
            <span class="st-story-item-content-container__mobile__type">{{ scriptStoryTypeLabel$ | ngrxPush }}</span>
            <div
                class="st-story-item-content-container__mobile__slug"
                [class.st-story-item-content-container__mobile__slug-required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.Title]?.Required && !data()?.Title">
                {{ data()?.Title || globalTablesService.FieldDefsDict[PSTFieldNames.Title]?.DefaultCaption }}
            </div>
            <textarea
                matInput
                cdkTextareaAutosize
                class="st-story-item-content-container__mobile__summary"
                [ngModel]="data()?.BeginText"
                [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.Description]?.DefaultCaption"
                [cdkAutosizeMinRows]="2"
                [cdkAutosizeMaxRows]="2"
                [disabled]="true">
            </textarea>
            <div class="st-story-item-content-container__mobile__row">
                <st-desk
                    class="st-story-item-content-container__mobile__desk"
                    [value]="data()?.PSTGroup"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTDesk]"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.Required"
                    [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.DefaultCaption"
                    [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.DefaultCaption"
                    [itemList]="globalTablesService.getListItemsForDesk(data()?.Type)"
                    (changed)="updateStory($event, PSTFieldNames.PSTDesk)" />
                <st-staff-id-list
                    class="st-story-item-content-container__mobile__owners"
                    [value]="data()?.PSTStoryOwner"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTStoryOwner]"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryOwner]?.Required"
                    [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryOwner]?.DefaultCaption"
                    (changed)="updateStory($event, PSTFieldNames.PSTStoryOwner)" />
                @if (topicRecord()?.Title) {
                    <st-topic-button
                        class="st-story-item-content-container__mobile__topic-button"
                        [class.st-story-item-content-container__mobile__topic-button--readonly]="!inFullscreenMode()"
                        [value]="topicRecord()?.Title"
                        [label]="addToTopicLabel()"
                        [inFullScreenMode]="showFullCard"
                        (topicOpenEmitter)="onTopicOpenHandler(topicRecord())" />
                }
            </div>
        </div>

        <div class="st-story-item-content-container__mobile__right">
            <div class="st-story-item-content-container__mobile__top-row">
                <span class="st-story-item-content-container__mobile__word-count">{{ wordCount() }}</span>
                <span class="st-story-item-content-container__mobile__time-updated">{{ timeUpdatedLabel }}</span>
                <span class="st-story-item-content-container__mobile__updated-by">{{ updatedBy }}</span>
            </div>
            <st-date-time-picker
                *ngIf="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Validation?.toUpperCase() === FieldDefValidations.TIME; else datePicker"
                class="st-story-item-content-container__mobile__date-picker"
                asCustomField
                [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.TargetPublicationDate]"
                [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Required"
                [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.DefaultCaption"
                [value]="data()?.[PSTFieldNames.TargetPublicationDate]"
                (onTimezoneChanged)="timezoneChanged(PSTFieldNames?.TargetPublicationDate, $event)"
                (changed)="updateStory($event, PSTFieldNames.TargetPublicationDate)" />
            <ng-template #datePicker>
                <st-date-picker
                    class="st-story-item-content-container__mobile__date-picker"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Required"
                    [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.DefaultCaption"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.TargetPublicationDate]"
                    [value]="data()?.[PSTFieldNames.TargetPublicationDate]"
                    (changed)="updateStory($event, PSTFieldNames.TargetPublicationDate)" />
            </ng-template>
            <div class="st-story-item-content-container__mobile__end-row">
                <st-status
                    class="st-story-item-content-container__mobile__status"
                    [value]="data()?.PSTStoryStatus"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTStoryStatus]"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.Required"
                    [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.DefaultCaption"
                    [matTooltip]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.DefaultCaption"
                    [itemList]="globalTablesService.getListItemsForField(PSTFieldNames.PSTStoryStatus)"
                    (changed)="updateStory($event, PSTFieldNames.PSTStoryStatus)" />
                <button
                    *ngIf="approvedVisible() && !cardDisabled()"
                    class="st-story-item-content-container__mobile__approve"
                    mat-icon-button
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.Approved]"
                    [matTooltip]="globalTablesService.FieldDefsDict[PSTFieldNames?.Approved]?.DefaultCaption"
                    [class.st-story-item-content-container-actions__approve--active]="data()?.Approved"
                    (click)="updateStory(!data()?.Approved, PSTFieldNames.Approved)">
                    <mat-icon>done</mat-icon>
                </button>
                <button
                    class="st-story-item-content-container__mobile__fullscreen"
                    mat-icon-button
                    [matTooltip]="displayOpenActionButtonHoverTitle()"
                    [disabled]="preview()"
                    (click)="itemClicked.emit()">
                    <mat-icon>fullscreen</mat-icon>
                </button>

                <st-external-actions-overlay
                    [inSidecarOpened]="inSidecarOpenedMode()"
                    [inFullScreen]="inFullscreenMode()"
                    [data]="data()"
                    [disabled]="cardDisabled()"
                    [editable]="!cardDisabled()"
                    [onObjectOpen]="itemClicked" />
            </div>
        </div>
    </div>
</ng-template>
